// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExpressContactStatusDto
 */
export interface IExpressContactStatusDto {
    /**
     * 
     * @type {number}
     * @memberof IExpressContactStatusDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IExpressContactStatusDto
     */
    contact_status: IExpressContactStatusDtoContactStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IExpressContactStatusDtoContactStatusEnum {
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED',
    PENDING = 'PENDING',
    EXPRESS_VERIFICATION = 'EXPRESS_VERIFICATION',
    EXPRESS_ORGANIZATION = 'EXPRESS_ORGANIZATION'
}


/**
 * Check if a given object implements the IExpressContactStatusDto interface.
 */
export function instanceOfIExpressContactStatusDto(value: object): value is IExpressContactStatusDto {
    if (!('contact_status' in value) || value['contact_status'] === undefined) return false;
    return true;
}

export function IExpressContactStatusDtoFromJSON(json: any): IExpressContactStatusDto {
    return IExpressContactStatusDtoFromJSONTyped(json, false);
}

export function IExpressContactStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressContactStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'contact_status': json['contact_status'],
    };
}

export function IExpressContactStatusDtoToJSON(json: any): IExpressContactStatusDto {
    return IExpressContactStatusDtoToJSONTyped(json, false);
}

export function IExpressContactStatusDtoToJSONTyped(value?: IExpressContactStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_id': value['organization_id'],
        'contact_status': value['contact_status'],
    };
}

